import React from 'react';

interface TextAreaFieldProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  rows?: number;
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({
  id,
  value,
  onChange,
  placeholder,
  disabled = false,
  maxLength,
  rows = 4,
}) => (
  <textarea
    id={id}
    name={id}
    value={value || ''}
    onChange={onChange}
    placeholder={placeholder}
    disabled={disabled}
    maxLength={maxLength}
    rows={rows}
    className="w-full rounded border border-gray-300 px-4 py-2 text-sm text-ink dark:border-white/20 
        dark:bg-white/5 dark:text-white/80 outline-none transition-all focus:border-primary dark:focus:border-primary"
  />
);

export default TextAreaField;
